import React, { useContext, useEffect, useState } from "react";
import styles from './style.module.css';
import { AuthContext } from "../../authContext";
import useStore from "../../store/store";
import serverPath from "../../utils/serverPath";
import { NavLink } from "react-router-dom";
const Admins = (props) =>
{
    const context = useContext(AuthContext);
    const [globalState] = useStore();
    const {admins} = globalState;

    useEffect(() =>
    {
      if(admins.length > 0)
      {
        window.loadTable();
      }
    }, [admins])

    let ndx = 0;
    return (
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h4>Your Admins</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-striped" id="table-1">
                        <thead>
                          <tr>
                            <th className="text-center">
                              #
                            </th>
                            <th>FirstName</th>
                            <th>LastName</th>
                            <th>Phone</th>
                            {/* <th>Image</th> */}
                            <th>Email</th>
                            <th>Date</th>
                            <th>Sale</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {admins.map((admin, index) => {
                            if(context.user.id === admin.id)
                              return null;
                            ndx += 1;
                          return (
                          <tr key={admin.id}>
                            <td>
                              {(ndx)}
                            </td>
                            <td>{admin.firstName}</td>
                            <td>{admin.lastName}</td>
                            <td>{admin.phone}</td>
                            {/* <td>
                              <a alt="image" href={serverPath(admin.image)} target="_blank">Preview</a>
                            </td> */}
                            <td>{admin.email}</td>
                            <td>{(new Date(admin.createdAt).toLocaleDateString())?.replace(/\//ig, "-")}</td>
                            <td>{admin.soldTokensCount}</td>
                            <td>
                              {
                                admin.status ?
                                <div className="badge badge-success badge-shadow">Active</div>
                                :
                                <div className="badge badge-warning badge-shadow">Suspended</div>
                              }
                            </td>
                            <td><NavLink to={`/admin/edit/${admin.id}`} className="btn btn-primary">Edit / Delete</NavLink></td>
                          </tr>
                          )})}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
        </section>
      </div>
    )
}


export default Admins;